import { atom } from "jotai";

import { RestrictionFeature } from "@whoosh/features/src/Restrictions/types";

import { PatronEditBooking } from "../types";

export const originalBookingAtom = atom<PatronEditBooking.Booking | null>(null);
export const currentBookingAtom = atom<PatronEditBooking.Booking | null>(null);

// Snapshot of the edit draft before opening the new-group picker.
export const pendingRequestGroupAtom = atom<{
  booking: PatronEditBooking.Booking;
  bookingIndex: number;
} | null>(null);

export const defaultMembershipTypeIdAtom = atom<string | null>(null);
export const currentSessionMemberShipTypeIdAtom = atom<string | null>(null);
export const currentSessionUserClientIdAtom = atom<string | null>(null);
export const originalBookingOwnerClientIdAtom = atom<string | null>(null);

export const currentModalStepAtom = atom<PatronEditBooking.ModalStep>({
  type: "EditRounds",
});

export const remainingSlotCapacityAtom = atom<number | null>(null);

/**
 * Round Restrictions are represented in a simple array in the same index order
 * as the rounds on our booking.
 */
export const roundRestrictionsAtom = atom<
  RestrictionFeature.RestrictionBarData[][]
>([]);
export const groupRestrictionsAtom = atom<
  RestrictionFeature.RestrictionBarData[] | null
>(null);

export const currentDurationOptionsAtom = atom<
  {
    courseId: string;
    endSlotOptions: {
      durationMins: number;
      allowedPlayerCounts: number[];
      slotId: string;
    }[];
  }[]
>([]);
